import { QUARTER } from 'legacy/lut/components/widgets/public/partner360/reports/configs'

import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'
import { ISobAnalyticsReportWeightedAverageNetNdp } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportWeightedAverage'

import { calcWeightedPair } from '../../weightedAverage/calcWeightedPair'

interface IParams {
  years: number[]
  reports: ISobAnalyticsReportJoined[]
}

export const calculateWeightedAverageNetNdp = ({ reports, years }: IParams) => {
  const quarterResults: ISobAnalyticsReportWeightedAverageNetNdp[] = []
  const yearlyResults: ISobAnalyticsReportWeightedAverageNetNdp[] = []

  years.forEach((year) => {
    const yearReports = reports.filter((r) => r.FYear === year)
    Array.from({ length: QUARTER }, (_, index) => {
      const quarter = index + 1

      const planKey = `SobPlanQ${quarter}` as keyof ISobAnalyticsReportJoined
      const actualKey = `SobActualQ${quarter}` as keyof ISobAnalyticsReportJoined

      const ndp = calcWeightedPair(
        yearReports,
        planKey,
        actualKey,
        `PlansCYQ${quarter}Ndp` as keyof ISobAnalyticsReportJoined,
        `ActualsCYQ${quarter}Ndp` as keyof ISobAnalyticsReportJoined
      )

      const net = calcWeightedPair(
        yearReports,
        planKey,
        actualKey,
        `PlansCYQ${quarter}Net` as keyof ISobAnalyticsReportJoined,
        `ActualsCYQ${quarter}Net` as keyof ISobAnalyticsReportJoined
      )

      const tnet = calcWeightedPair(
        yearReports,
        planKey,
        actualKey,
        `PlansCYQ${quarter}TNet` as keyof ISobAnalyticsReportJoined,
        `ActualsCYQ${quarter}TNet` as keyof ISobAnalyticsReportJoined
      )

      const utnet = calcWeightedPair(
        yearReports,
        planKey,
        actualKey,
        `PlansCYQ${quarter}UTNet` as keyof ISobAnalyticsReportJoined,
        `ActualsCYQ${quarter}UTNet` as keyof ISobAnalyticsReportJoined
      )

      quarterResults.push({
        year,
        quarter: `Q${quarter}`,
        plans: ndp.plans,
        actuals: ndp.actuals,
        plansNet: net.plans,
        actualsNet: net.actuals,
        plansTNet: tnet.plans,
        actualsTNet: tnet.actuals,
        plansUTNet: utnet.plans,
        actualsUTNet: utnet.actuals,
      })
    })

    const ndpFY = calcWeightedPair(
      yearReports,
      'SobPlanFY',
      'SobActualFY',
      'PlansCYNdp',
      'ActualsCYNdp'
    )

    const netFY = calcWeightedPair(
      yearReports,
      'SobPlanFY',
      'SobActualFY',
      'PlansCYNet',
      'ActualsCYNet'
    )

    const tnetFY = calcWeightedPair(
      yearReports,
      'SobPlanFY',
      'SobActualFY',
      'PlansCYTNet',
      'ActualsCYTNet'
    )

    const utnetFY = calcWeightedPair(
      yearReports,
      'SobPlanFY',
      'SobActualFY',
      'PlansCYUTNet',
      'ActualsCYUTNet'
    )

    yearlyResults.push({
      year,
      quarter: 'FY',
      plans: ndpFY.plans,
      actuals: ndpFY.actuals,
      plansNet: netFY.plans,
      actualsNet: netFY.actuals,
      plansTNet: tnetFY.plans,
      actualsTNet: tnetFY.actuals,
      plansUTNet: utnetFY.plans,
      actualsUTNet: utnetFY.actuals,
    })
  })

  return {
    quarterResults,
    yearlyResults,
  }
}
